import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const LOGO_SRC = {
  lavender: '/images/logo-lavender.png',
  white: '/images/logo-white.png',
  periwinkle: '/images/logo-periwinkle.png',
  chalkboard: '/images/logo-chalkboard.png',
}

/**
 * Official Social Box logo.
 * @param {'lavender'|'white'|'periwinkle'|'chalkboard'} variant - Lavender/periwinkle for light backgrounds, white for dark/over imagery, chalkboard for dark/chalkboard theme
 * @param {number|string} height - Logo height (default 52)
 * @param {object} sx - Additional MUI sx
 */
export const Logo = ({ variant = 'lavender', height = 52, sx = {}, ...props }) => (
  <Box
    component="img"
    src={LOGO_SRC[variant] ?? LOGO_SRC.lavender}
    alt="Social Box"
    sx={{
      height,
      width: 'auto',
      objectFit: 'contain',
      display: 'block',
      ...sx,
    }}
    {...props}
  />
)

Logo.propTypes = {
  variant: PropTypes.oneOf(['lavender', 'white', 'periwinkle', 'chalkboard']),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.object,
}

/**
 * "Powered by" footer with small logo. Use on auth pages when tenant is set.
 */
export const PoweredByLogo = ({ sx = {} }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, mt: 3, ...sx }}>
    <Typography variant="caption" color="text.secondary">Powered by</Typography>
    <Logo variant="lavender" height={28} />
  </Box>
)

PoweredByLogo.propTypes = {
  sx: PropTypes.object,
}
